import _ from 'lodash';

const stockCodeColors = {};

function getStockCodeColor(stock_code) {
    let className = stockCodeColors[stock_code];

    if (!className) {
        let l = _.keys(stockCodeColors).length;
        let c = `hk-option-row-${l%7 + 1}`;
        stockCodeColors[stock_code] = c;
        return c;
    }
    return className;
}


export default getStockCodeColor;